<template>
  <div class="content">
    <div class="container-fluid">
      <div class="row">
        <div class="col-12" v-if="isAdmin">
          <card>
            <h4 slot="header" class="card-title">Supplier Data</h4>

            <div class="row">
              <div class="col-md-3">
                <base-input
                  type="date"
                  label="Date"
                  placeholder="Date"
                  v-model="supplier.sDate"
                ></base-input>
              </div>
              <div class="col-md-2">
                <base-input
                  type="text"
                  label="Code"
                  placeholder="Code"
                  v-model="supplier.sCode"
                ></base-input>
              </div>
              <div class="col-md-3">
                <label class="form-label">Type</label>
                <select
                  class="form-control"
                  v-model="supplier.sType"
                  @change="onTypeChange"
                >
                  <option value="">Select Type</option>
                  <option
                    v-for="type in supplierTypes"
                    :key="type.id"
                    :value="type.type_name"
                  >
                    {{ type.type_name }}
                  </option>
                  <option value="__new__">+ Add New Type</option>
                </select>
                <input
                  v-if="showCustomTypeInput"
                  type="text"
                  class="form-control mt-2"
                  placeholder="Enter new type"
                  v-model="customType"
                  @blur="addCustomType"
                  @keyup.enter="addCustomType"
                />
              </div>
              <div class="col-md-2">
                <base-input
                  type="number"
                  label="In"
                  placeholder="In"
                  v-model="supplier.sIn"
                ></base-input>
              </div>
              <div class="col-md-2">
                <base-input
                  type="number"
                  label="Out"
                  placeholder="Out"
                  v-model="supplier.sOut"
                ></base-input>
              </div>
              <div class="col-md-3">
                <base-input
                  type="text"
                  label="Supplier"
                  placeholder="Supplier"
                  v-model="supplier.supplier"
                ></base-input>
              </div>
              <div class="col-md-6">
                <base-input
                  type="text"
                  label="Remark"
                  placeholder="Remark"
                  v-model="supplier.remark"
                ></base-input>
              </div>
            </div>
            <div class="text-right">
              <button
                v-if="supplier.id"
                @click="cancelEdit"
                class="btn mr-3 btn-secondary btn-fill btn-sm"
              >
                Cancel
              </button>
              <button
                v-if="editIndex == -1"
                class="btn btn-primary btn-fill btn-sm"
                @click="addNewData"
              >
                Save
              </button>
              <button
                v-if="editIndex !== -1"
                class="btn btn-primary btn-fill btn-sm"
                @click="saveUser(editIndex)"
              >
                Update
              </button>
            </div>
          </card>
        </div>
        <div class="col-12">
          <card>
            <h5 slot="header" class="card-title">Filters</h5>
            <div class="row">
              <div class="col-md-3">
                <base-input
                  type="date"
                  label="Start Date"
                  v-model="filters.startDate"
                ></base-input>
              </div>
              <div class="col-md-3">
                <base-input
                  type="date"
                  label="End Date"
                  v-model="filters.endDate"
                ></base-input>
              </div>
              <div class="col-md-3">
                <label class="form-label">Type</label>
                <multiselect
                  v-model="filters.supplierType"
                  :options="supplierTypes"
                  :multiple="true"
                  :close-on-select="false"
                  placeholder="Select types"
                  label="type_name"
                  track-by="type_name"
                ></multiselect>
              </div>
              <div class="col-md-3">
                <base-input
                  type="text"
                  label="Code/Remark"
                  placeholder="Enter Code/Remark"
                  v-model="filters.codeRemark"
                ></base-input>
              </div>
            </div>
            <div class="text-right mt-3">
              <button
                @click="loadSupplierWithFilters"
                class="btn btn-primary btn-sm"
              >
                Apply Filters
              </button>
            </div>
          </card>
        </div>
        <div class="col-12">
          <card
            class="strpied-tabled-with-hover"
            body-classes="table-full-width table-responsive"
          >
            <template slot="header">
              <div class="d-flex justify-content-between align-items-center">
                <div>
                  <h4 class="card-title">Supplier List</h4>
                  <div class="mt-2">
                    <h5 class="text-muted">
                      Total Records: {{ dataList.length }} |
                      <strong>OVERALL TOTALS</strong> - In:
                      <strong>{{
                        formatCurrency(overallTotal.totalIn)
                      }}</strong>
                      | Out:
                      <strong>{{
                        formatCurrency(overallTotal.totalOut)
                      }}</strong>
                      | Balance:
                      <strong>{{
                        formatCurrency(overallTotal.totalBalance)
                      }}</strong>
                    </h5>
                  </div>
                </div>
              </div>
            </template>
            <div class="card-body">
              <table id="myTable" class="table table-hover table-striped">
                <thead>
                  <tr>
                    <th v-for="column in tableColumns" :key="column">
                      {{ column }}
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(row, index) in dataList">
                    <td>{{ row.id }}</td>
                    <td>{{ row.sDate }}</td>
                    <td>{{ row.sCode }}</td>
                    <td>{{ row.sType }}</td>
                    <td>{{ row.sIn }}</td>
                    <td>{{ row.sOut }}</td>
                    <td>{{ row.balance }}</td>
                    <td>{{ row.supplier }}</td>
                    <td>{{ row.remark }}</td>
                    <td v-if="isAdmin">
                      <button
                        @click="editUser(index, row)"
                        class="btn btn-primary btn-sm"
                      >
                        Edit
                      </button>
                      <button
                        @click="deleteUser(row.id)"
                        class="btn btn-danger btn-sm"
                      >
                        Delete
                      </button>
                    </td>
                  </tr>
                </tbody>
                <tfoot v-if="dataList.length > 0">
                  <tr class="table-info font-weight-bold">
                    <td colspan="4" class="text-right">
                      <strong>PAGE TOTALS:</strong>
                    </td>
                    <td>
                      <strong>{{ formatCurrency(pageTotal.totalIn) }}</strong>
                    </td>
                    <td>
                      <strong>{{ formatCurrency(pageTotal.totalOut) }}</strong>
                    </td>
                    <td>
                      <strong>{{
                        formatCurrency(pageTotal.totalBalance)
                      }}</strong>
                    </td>
                    <td></td>
                    <!-- Supplier column -->
                    <td></td>
                    <!-- Remark column -->
                    <td v-if="isAdmin"></td>
                    <!-- Action column -->
                  </tr>
                </tfoot>
              </table>
            </div>
          </card>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Card from "src/components/Cards/Card.vue";
import axios from "axios";
import moment from "moment";
import Multiselect from "vue-multiselect";
import {
  fetchSupplierList,
  fetchSupplierTypes,
  fetchSupplierListWithFilters,
  createSupplier,
  updateSupplier,
  deleteSupplier,
} from "src/utils/api";

export default {
  components: {
    Card,
    Multiselect,
  },
  data() {
    return {
      editIndex: -1,
      editItem: {},
      selectedUsers: [],
      selectAll: false,
      showCustomTypeInput: false,
      customType: "",
      supplierTypes: [],
      filters: {
        startDate: "",
        endDate: "",
        supplierType: [],
        codeRemark: "",
      },
      supplier: {
        id: "",
        sDate: "",
        sCode: "",
        sType: "",
        sIn: "",
        sOut: "",
        supplier: "",
        remark: "",
      },
      dataList: [],
      pageTotal: {
        totalIn: 0,
        totalOut: 0,
        totalBalance: 0,
      },
      overallTotal: {
        totalIn: 0,
        totalOut: 0,
        totalBalance: 0,
      },
    };
  },
  computed: {
    isAdmin() {
      return localStorage.getItem("role") == "developer" ||
        localStorage.getItem("role") == "admin"
        ? true
        : false;
    },
    tableColumns() {
      if (this.isAdmin) {
        return [
          "Id",
          "Date",
          "Code",
          "Type",
          "In",
          "Out",
          "Balance",
          "Supplier",
          "Remark",
          "Action",
        ];
      } else {
        return [
          "Id",
          "Date",
          "Code",
          "Type",
          "In",
          "Out",
          "Balance",
          "Supplier",
          "Remark",
        ];
      }
    },
  },
  mounted() {
    this.setDefaultDates();
    this.setDefaultSupplierDate();
    this.loadSupplierTypes();
    this.loadSupplierWithFilters();
  },
  methods: {
    validateForm() {
      if (!this.supplier.sDate) {
        alert("Date is required");
        return false;
      }
      if (!this.supplier.sCode) {
        alert("Code is required");
        return false;
      }
      return true;
    },
    setDefaultSupplierDate() {
      const today = new Date();
      this.supplier.sDate = today.toISOString().split("T")[0];
    },
    setDefaultDates() {
      const today = new Date();
      const yesterday = new Date(today);
      yesterday.setDate(yesterday.getDate() - 1);
      const tomorrow = new Date(today);
      tomorrow.setDate(tomorrow.getDate() + 1);

      this.filters.startDate = yesterday.toISOString().split("T")[0];
      this.filters.endDate = tomorrow.toISOString().split("T")[0];
    },
    formatCurrency(amount) {
      if (!amount && amount !== 0) return "0.00";
      return parseFloat(amount).toLocaleString("en-US", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });
    },
    calculateOverallTotals() {
      this.overallTotal = {
        totalIn: 0,
        totalOut: 0,
        totalBalance: 0,
      };

      this.dataList.forEach((rowData) => {
        const sIn = parseFloat(rowData.sIn || 0);
        const sOut = parseFloat(rowData.sOut || 0);
        const balance = parseFloat(rowData.balance || 0);

        this.overallTotal.totalIn += sIn;
        this.overallTotal.totalOut += sOut;
        this.overallTotal.totalBalance += balance;
      });

      console.log("Overall Totals calculated:", this.overallTotal);
    },
    calculatePageTotals() {
      this.pageTotal = {
        totalIn: 0,
        totalOut: 0,
        totalBalance: 0,
      };

      if ($.fn.DataTable.isDataTable("#myTable")) {
        const table = $("#myTable").DataTable();
        const visibleIndexes = table.rows({ page: "current" }).indexes();

        for (let i = 0; i < visibleIndexes.length; i++) {
          const rowIndex = visibleIndexes[i];
          const rowData = this.dataList[rowIndex];

          if (rowData) {
            const sIn = parseFloat(rowData.sIn || 0);
            const sOut = parseFloat(rowData.sOut || 0);
            const balance = parseFloat(rowData.balance || 0);

            this.pageTotal.totalIn += sIn;
            this.pageTotal.totalOut += sOut;
            this.pageTotal.totalBalance += balance;
          }
        }

        console.log("Page Totals calculated:", this.pageTotal);
      }
    },
    async loadSupplierTypes() {
      try {
        const response = await fetchSupplierTypes();
        this.supplierTypes = response.data || [];
      } catch (error) {
        console.error("Error loading supplier types:", error);
        this.supplierTypes = [];
      }
    },
    async loadSupplierWithFilters() {
      let self = this;
      this.dataList = [];

      if ($.fn.DataTable.isDataTable("#myTable")) {
        $("#myTable").DataTable().clear().destroy();
      }

      try {
        const response = await fetchSupplierListWithFilters(this.filters);
        const data = response.data || [];

        data.forEach((item) => {
          item.balance = parseFloat(item.sIn || 0) - parseFloat(item.sOut || 0);
        });

        this.dataList = [...data];
        this.calculateOverallTotals();
        console.log(this.dataList, "loadSupplierWithFilters");

        this.$nextTick(() => {
          $("#myTable").DataTable({
            pageLength: 10,
            lengthMenu: [10, 25, 50, 100],
            language: {
              lengthMenu: "Show _MENU_ entries",
            },
            order: [[1, "desc"]],
            autoWidth: false,
            columns: [
              { title: "Id" },
              { title: "Date" },
              { title: "Code" },
              { title: "Type" },
              { title: "In" },
              { title: "Out" },
              { title: "Balance" },
              { title: "Supplier" },
              { title: "Remark" },
              ...(this.isAdmin ? [{ title: "Action", orderable: false }] : []),
            ],
            // Add column width configuration to match Report.vue
            columnDefs: [
              { width: "5%", targets: 0 }, // Id
              { width: "10%", targets: 1 }, // Date
              { width: "10%", targets: 2 }, // Code
              { width: "8%", targets: 3 }, // Type
              { width: "10%", targets: 4 }, // In
              { width: "10%", targets: 5 }, // Out
              { width: "10%", targets: 6 }, // Balance
              { width: "12%", targets: 7 }, // Supplier
              { width: "15%", targets: 8 }, // Remark
              { width: "10%", targets: 9, orderable: false }, // Action (if admin)
            ],
            drawCallback: function () {
              setTimeout(() => {
                self.calculatePageTotals();
              }, 50);
            },
          });
        });

        this.calculatePageTotals();
      } catch (error) {
        console.error("Error loading supplier data:", error);
        this.dataList = [];
      }
    },
    onTypeChange() {
      if (this.supplier.sType === "__new__") {
        this.showCustomTypeInput = true;
        this.supplier.sType = "";
      } else {
        this.showCustomTypeInput = false;
      }
    },
    async addCustomType() {
      if (this.customType.trim()) {
        try {
          const response = await axios.post(
            `${process.env.VUE_APP_BASE_URL}?action=addSupplierType`,
            { type_name: this.customType.trim() }
          );

          if (response.data.status === "success") {
            this.supplier.sType = this.customType.trim();
            this.showCustomTypeInput = false;
            this.customType = "";
            this.loadSupplierTypes();
          }
        } catch (error) {
          console.error("Error adding custom type:", error);
        }
      }
    },
    async addNewData() {
      if (!this.validateForm()) return;

      try {
        const saveButton = document.querySelector(
          'button[class*="btn-primary"]'
        );
        if (saveButton) {
          saveButton.disabled = true;
          saveButton.textContent = "Saving...";
        }

        const balance =
          parseFloat(this.supplier.sIn || 0) -
          parseFloat(this.supplier.sOut || 0);

        const supplierData = {
          sDate: this.supplier.sDate,
          sCode: this.supplier.sCode,
          sType: this.supplier.sType,
          sIn: this.supplier.sIn,
          sOut: this.supplier.sOut,
          balance: balance,
          supplier: this.supplier.supplier,
          remark: this.supplier.remark,
        };

        const response = await createSupplier(supplierData);

        if (response.status === "success") {
          alert("Supplier added successfully!");
          this.resetForm();
          this.loadSupplierWithFilters();
        } else {
          alert("Error: " + response.message);
        }
      } catch (error) {
        console.error("Error adding supplier:", error);
        alert("Error adding supplier. Please try again.");
      } finally {
        const saveButton = document.querySelector(
          'button[class*="btn-primary"]'
        );
        if (saveButton) {
          saveButton.disabled = false;
          saveButton.textContent = "Save";
        }
      }
    },
    resetForm() {
      this.supplier = {
        id: "",
        sDate: "",
        sCode: "",
        sType: "",
        sIn: "",
        sOut: "",
        supplier: "",
        remark: "",
      };
      this.editIndex = -1;
      this.editItem = {};
    },
    editUser(index, row) {
      this.editIndex = index;
      this.editItem = { ...row };
      this.supplier = { ...row };
    },
    async saveUser(index) {
      if (!this.validateForm()) return;

      try {
        if (!this.supplier.sCode) {
          alert("Code is required");
          return;
        }

        const balance =
          parseFloat(this.supplier.sIn || 0) -
          parseFloat(this.supplier.sOut || 0);

        const supplierData = {
          id: this.supplier.id,
          sDate: this.supplier.sDate,
          sCode: this.supplier.sCode,
          sType: this.supplier.sType,
          sIn: this.supplier.sIn,
          sOut: this.supplier.sOut,
          balance: balance,
          supplier: this.supplier.supplier,
          remark: this.supplier.remark,
        };

        const response = await updateSupplier(supplierData);

        if (response.status === "success") {
          alert("Supplier updated successfully!");
          this.cancelEdit();
          this.loadSupplierWithFilters();
        } else {
          alert("Error: " + response.message);
        }
      } catch (error) {
        console.error("Error updating supplier:", error);
        alert("Error updating supplier. Please try again.");
      }
    },
    cancelEdit() {
      this.editIndex = -1;
      this.editItem = {};
      this.supplier = {
        id: "",
        sDate: "",
        sCode: "",
        sType: "",
        sIn: "",
        sOut: "",
        supplier: "",
        remark: "",
      };
    },
    async deleteUser(id) {
      if (confirm("Are you sure you want to delete this supplier record?")) {
        try {
          const response = await deleteSupplier(id);

          if (response.status === "success") {
            alert("Supplier deleted successfully!");
            this.loadSupplierWithFilters();
          } else {
            alert("Error: " + response.message);
          }
        } catch (error) {
          console.error("Error deleting supplier:", error);
          alert("Error deleting supplier. Please try again.");
        }
      }
    },
  },
};
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<style scoped>
.table-scroll-container {
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
  width: 100%;
}

.table {
  min-width: 1000px;
  width: 100% !important;
}

/* Add specific styles for table cells */
#myTable td,
#myTable th {
  white-space: nowrap;
  padding: 8px 12px;
}

/* Ensure footer cells align properly */
.table tfoot td {
  font-weight: bold;
  background-color: #d1ecf1 !important;
}

.table-info {
  background-color: #d1ecf1 !important;
}

.font-weight-bold {
  font-weight: bold !important;
}

/* Ensure action buttons don't wrap */
#myTable td:last-child {
  white-space: nowrap;
}
#myTable td:last-child button {
  margin-right: 5px;
  margin-bottom: 5px;
}

/* Multiselect custom styling */
.multiselect {
  min-height: 38px;
}

.multiselect__tags {
  min-height: 38px;
  padding: 6px 40px 0 8px;
  border: 1px solid #ccc;
  border-radius: 4px;
}

.multiselect__select {
  height: 38px;
}

.multiselect__placeholder {
  margin-bottom: 8px;
  padding-top: 0px;
  color: #999;
}
</style>